import { defineMessages } from 'react-intl-next';

export default defineMessages({
	iframeTitle: {
		id: 'smart-creation.preview.iframe.title',
		defaultMessage: 'Content preview',
		description: 'Accessible title for the preview iframe.',
	},
	loadingMessage: {
		id: 'smart-creation.preview.loading',
		defaultMessage: 'Loading...',
		description: 'Loading message for the preview iframe.',
	},
	errorMessage: {
		id: 'smart-creation.preview.error',
		defaultMessage: 'Unable to load preview',
		description: 'Error message when preview fails to load.',
	},
});
